import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatasharingService {
  public storageSource = new BehaviorSubject(JSON.parse((localStorage.getItem('user'))));
  currentStorage = this.storageSource.asObservable();
  constructor() { }

  changeStorage(message: string) {
    this.storageSource.next(message)
  }
  
}
